import queryStringify from './query-stringify';

class ClientSideUrls {
  getBasePathFromSettings() {
    return process.env.PUBLIC_URL;
  }

  generate(path = '', query = null) {
    const publicUrl = this.getBasePathFromSettings();
    const { protocol, host } = document.location;

    let preparedUrl = `${protocol}//${host}${publicUrl}${path}`;

    if (query) {
      preparedUrl += `?${queryStringify(query)}`;
    }
    
    return preparedUrl;
  }

  getClientRootUrl() {
    return this.generate();
  }

  getClientRootPath() {
    return this.getBasePathFromSettings() || '/';
  }

  generateVacancyApplicationUrl(schoolId, vacancyId, applicationId) {
    return this.generate(`/schools/${schoolId}/vacancies/${vacancyId}/applications/${applicationId}`)
  }
}

export default new ClientSideUrls();


// WEBPACK FOOTER //
// ./src/tools/client-side-urls.js